import {
  IconPlaneTilt,
  IconWorldSearch,
  IconPlayerPause,
  IconBuildingStore,
  IconShoppingBag,
  IconCash,
  IconBell
} from '@tabler/icons-react';

const typeConfig = {
  flight_deal_match: { icon: IconPlaneTilt, label: 'Flight Deal' },
  ai_flight_deal_ready: { icon: IconWorldSearch, label: 'AI Flight Deal' },
  flight_deal_tracker_disabled: { icon: IconPlayerPause, label: 'Tracker Disabled' },
  trip_guide_sold: { icon: IconBuildingStore, label: 'Trip Guide Sold' },
  trip_guide_purchased: { icon: IconShoppingBag, label: 'Trip Guide Purchased' },
  payment_received: { icon: IconCash, label: 'Payment Received' }
};

const priorityColorMap = {
  success: '#00c853',
  urgent: '#f44336',
  info: '#757575'
};

export const getNotificationConfig = (type, priority) => {
  const config = typeConfig[type] || { icon: IconBell, label: 'Notification' };
  const color = priorityColorMap[priority] || priorityColorMap.info;
  return { ...config, color };
};

// Types that open a dialog instead of navigating
const dialogTypes = ['ai_flight_deal_ready'];

export const isDialogNotification = (type) => dialogTypes.includes(type);

// Per-type overrides (when the same resource_type needs different routes)
const typeRouteOverrides = {
  trip_guide_sold: () => '/influencer/sales-dashboard'
};

// Route map for navigation-based notifications only
const resourceRouteMap = {
  flight_deal: () => '/collection',
  user_flight_deal_tracker: (id) => `/notification-settings?tracker_id=${id}`,
  trip_guide: (id) => `/trip-guide-studio?ptg_id=${id}`
  // stripe_transfer -- deferred
};

export const getNotificationUrl = (resourceType, resourceId, notificationType) => {
  const overrideFn = notificationType && typeRouteOverrides[notificationType];
  if (overrideFn) return overrideFn(resourceId);
  const routeFn = resourceRouteMap[resourceType];
  return routeFn ? routeFn(resourceId) : null;
};

export const formatRelativeTime = (dateString) => {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);

  if (diffMin < 1) return 'Just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHr < 24) return `${diffHr}h ago`;
  if (diffDay < 7) return `${diffDay}d ago`;
  return date.toLocaleDateString();
};
